
















































































































import { Component, Ref, Prop, Vue } from "vue-property-decorator";
import { VForm } from "@/common/vuetify_types";
import { Rooms, RoomStatus } from "@/api";
import { selfData } from "@/common/role_utils";
import { maxFileSize } from "@/tool/validation";

@Component
export default class RoomStatusForm extends Vue {
  @Ref("form") form!: VForm;
  @Prop() payload!: RoomStatus;
  @Prop() isupdate!: boolean;
  @Prop() floorId!: number;

  status: RoomStatus = JSON.parse(JSON.stringify(this.payload));
  statusList = ["clean", "dirty", "refused"];
  saving = false;
  counter = 0;
  url: string | ArrayBuffer | null | undefined = "";
  document: File | null = null;
  documentName = "";
  comment = "";
  fileErr = "";
  fileRules = [
    (v: File) => !v || maxFileSize(v, 5),
    // (v: File) => !!v || "File is required",
  ];

  created() {
    if (this.status.roomId && this.floorId) {
      this.selectFloor();
    }
  }

  get rooms() {
    return this.$store.getters["room/companyRooms"] as Rooms;
  }

  get beds() {
    return this.$store.getters["bed/beds"];
  }

  selectFloor() {
    const selectedRoom = this.rooms.find(
      room => room.id === this.status.roomId,
    );
    if (!selectedRoom) return;
    this.floorId = selectedRoom.floorId || 0;
    if (!this.floorId || !this.status.roomId) return;
    this.$store.dispatch("bed/fetchRoomBeds", {
      floorId: this.floorId,
      roomId: this.status.roomId,
    });
  }

  update() {
    const valid = this.form.validate();
    if (valid) {
      const payload = {
        ...this.status,
        comment: this.comment,
        createdBy: {
          id:
            this.status.status != "dirty"
              ? this.status.createdBy.id
              : selfData().id,
          name:
            this.status.status != "dirty"
              ? this.status.createdBy.name
              : selfData().firstName + " " + selfData().lastName,
        },
        updatedBy: {
          id: selfData().id,
          name: selfData().firstName + " " + selfData().lastName,
        },
      };

      this.submit(payload, "updateRoomStatus");
    }
  }

  save() {
    const valid = this.form.validate();
    if (valid) {
      const payload = {
        ...this.status,
        comment: this.comment,
        createdBy: {
          id: selfData().id,
          name: selfData().firstName + " " + selfData().lastName,
        },
      };

      this.submit(payload, "addRoomStatus");
    }
  }

  submit(room: RoomStatus, action: string) {
    this.saving = true;
    if (action == "addRoomStatus") {
      this.$store
        .dispatch(`room/${action}`, room)
        .then(() => {
          this.saving = false;
          this.$emit("close");
        })
        .catch(() => {
          this.saving = false;
        });
    } else {
      this.$store
        .dispatch(`room/${action}`, {
          requestBody: room,
          document: this.document || undefined,
        })
        .then(() => {
          this.saving = false;
          this.$emit("close");
        })
        .catch(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }

  onChangeFile(file: File) {
    this.fileErr = "";
    this.counter++;
    if (file) {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event) {
          this.documentName = file.name;
          this.url = URL.createObjectURL(file);
        }
      };
      reader.readAsArrayBuffer(file);
      this.document = file;
    }
  }
}
